import template from './footer.template.html';
import controller from './footer.controller';

const footerComponent = {
  template,
  controller,
  controllerAs: 'footerCtrl'
};

export default footerComponent;



// WEBPACK FOOTER //
// ./ui/src/components/footer/footer.component.js